import React from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import { Global, css } from "@emotion/react";
import { ChakraProvider, ColorModeScript } from "@chakra-ui/react";
import { generateTheme } from "./styles/theme";
import useFetch from "./hooks/useFetch";
import Archive from "./pages/Archive";
import Single from "./pages/Single";
import GlobalStyles from "./styles/GlobalStyles";

function App({ config }) {
  const settingsUrl = `${config.apiUrl}/settings`;
  const [{ loading, error, data: settings }] = useFetch(settingsUrl);

  // const location = useLocation();
  // console.log(location);
  // useEffect(() => {
  //   console.log("Location changed");
  //   console.log(location);
  // }, [location]);

  if ((loading && !settings) || error) return null;

  const theme = generateTheme({
    theme: settings.theme_json,
    fonts: {
      body: settings.theme_body_font_family,
      heading: settings.theme_heading_font_family,
      mono: settings.theme_mono_font_family,
    },
  });

  return (
    <div id="wp-resources-pro">
      <ChakraProvider resetCSS={true} theme={theme}>
        <ColorModeScript initialColorMode={theme.config.initialColorMode} />
        <GlobalStyles />
        <Global
          styles={css({
            "#wp-resources-pro": {
              backgroundColor: settings.theme_background_color
                ? settings.theme_background_color
                : null,
              // a: {
              //   color: settings.theme_color_scheme
              //     ? `${settings.theme_color_scheme}.900`
              //     : null,
              // },
            },
          })}
        />
        <BrowserRouter>
          <Switch>
            {/* <ScaleFade initialScale={0.9} in={selected} reverse={true} unmountOnExit> */}
            <Route
              path={`/${config.slug}/:slug`}
              render={(props) => (
                <Single {...props} config={config} settings={settings} />
              )}
            />
            <Route
              path={`/${config.slug}`}
              component={(props) => (
                <Archive {...props} config={config} settings={settings} />
              )}
            />
            {/* <Route path="/search/:term" component={Archive} /> */}
          </Switch>
        </BrowserRouter>
      </ChakraProvider>
    </div>
  );
}

export default App;

// // http://michaelsoriano.com/wordpress-theme-react-part-2-routes-context/

// import React from "react";
// import { BrowserRouter, Switch, Route } from "react-router-dom";
// // import { Global, css } from "@emotion/react";
// import { Spinner, Box } from "@chakra-ui/react";
// import useFetch from "./hooks/useFetch";
// import Archive from "./pages/Archive";
// import Single from "./pages/Single";
// import "./styles/global.css";

// function App(config) {
//   const settingsUrl = `${config.apiUrl}/settings`;

//   const [{ loading, error, data: settings }] = useFetch(settingsUrl);

//   if ((loading && !settings) || error)
//     return (
//       <Box
//         display="flex"
//         justifyContent="center"
//         alignItems="center"
//         w="100%"
//         h="100%"
//         minH="80vh"
//         bgColor="white"
//       >
//         <Spinner
//           thickness="4px"
//           speed="0.65s"
//           emptyColor="gray.200"
//           color="gray.500"
//           size="xl"
//         />
//       </Box>
//     );

//   return (
//     <Box>
//       {/* <Global
//         styles={css`
//           // setting css overrides go here
//         `}
//       /> */}
//       <BrowserRouter>
//         <Switch>
//           {/* <ScaleFade initialScale={0.9} in={selected} reverse={true} unmountOnExit> */}
//           <Route
//             path={`/${config.slug}/:slug`}
//             render={(props) => (
//               <Single {...props} config={config} settings={settings} />
//             )}
//           />
//           <Route
//             path={`/${config.slug}`}
//             component={(props) => (
//               <Archive {...props} config={config} settings={settings} />
//             )}
//           />
//           {/* <Route path="/search/:term" component={Archive} /> */}
//         </Switch>
//       </BrowserRouter>
//     </Box>
//   );
// }

// export default App;
